import { useCallback, useEffect, useState } from 'react';
import { useAPI } from '../../../clients/quipli-service/quipli-service-client';
import { Typography } from '../../../components/typography/typography';
import { General } from './tabs/general';
import { Addresses } from './tabs/addresses';
import { PaymentMethods } from './tabs/payment-methods';
import { Documents } from './tabs/documents';
import './user-setup.scss';
import { useParams, useSearchParams } from 'react-router-dom';
import { User } from '../../../clients/quipli-service/user/user';
import { Spinner } from '../../../components/spinner/spinner';
import Icon from '../../../components/icons/icon';
import { useNavigate } from 'react-router-dom';
import { TabNav } from '../../../components/tab-nav/tab-nav';
import { UserCollectibles } from './tabs/collectibles';
import { useAdmin } from '../../../hooks/use-admin-context';
import { Constants } from '../../../constants/constants';
import { Representatives } from './tabs/representatives';
import { OrderList } from '../../order/order-list';
import { WorkOrderList } from '../../service-and-repair/work-orders/work-order-list';
import { Pricing } from './tabs/pricing';

export const UserSetupView = () => {
  const { userId } = useParams();
  return <UserSetup userId={parseInt(userId!)} />;
};

export const UserSetup = ({ userId }: { userId: number }) => {
  const { hasPermissions } = useAdmin();
  const { getUserById } = useAPI();
  const [searchParams, setSearchParams] = useSearchParams();

  const [isContentLoading, setContentLoader] = useState<boolean>(true),
    [userObj, setUser] = useState<User>();

  const navigate = useNavigate();

  const init = async () => {
    setContentLoader(true);
    try {
      const user = await getUserById(userId);
      setUser(user);
      setContentLoader(false);
    } catch (e: any) {
      console.error(e);
    }
  };

  // Hooks
  useEffect(() => {
    init();
  }, []);

  const onSelectTab = useCallback(
    (tabName: string) => {
      searchParams.set('tab', tabName);
      setSearchParams(searchParams);
      if (userObj) {
        switch (tabName) {
          case 'General':
            return <General user={userObj} setUser={setUser} />;
          case 'Representatives':
            return <Representatives user={userObj} />;
          case 'Addresses':
            return <Addresses user={userObj} />;
          case 'Pricing':
            return <Pricing user={userObj} />;
          case 'Collectibles':
            return <UserCollectibles user={userObj} />;
          case 'Payment Methods':
            return <PaymentMethods user={userObj} />;
          case 'Orders':
            return <OrderList title={''} createOrderButton={false} scanQrButton={false} user={userObj} />;
          case 'Work Orders':
            return <WorkOrderList title={''} user={userObj} />;
          case 'Documents':
            return <Documents user={userObj} setUser={setUser} />;
        }
      }

      return undefined;
    },
    [userObj],
  );

  return (
    <div className="user-setup">
      {isContentLoading ? (
        <Spinner />
      ) : (
        <div className="container-v2">
          <div onClick={() => navigate(-1)}>
            <Icon icon="Back" size="large" />
          </div>
          <div className="flex justify-between items-center">
            <Typography type="display-sm" weight="medium">
              User Setup
            </Typography>
          </div>

          <TabNav
            tabNames={[
              'General',
              ...(userObj?.structureType == 'company' ? ['Representatives'] : []),
              'Addresses',
              'Pricing',
              ...(hasPermissions(Constants.Permissions.Collectibles) ? ['Collectibles'] : []),
              'Payment Methods',
              'Orders',
              'Work Orders',
              'Documents',
            ]}
            initialTab={searchParams.get('tab') || undefined}
            onSelect={onSelectTab}
          />
        </div>
      )}
    </div>
  );
};
